import { Box, Modal, Typography } from '@mui/material';
import { useCreateIntegration, useGetNewIntegrationsFields } from 'apis/business/setting/integrations/hook';
import Button from 'components/Common/Button';
import Input from 'components/Common/Input';
import Spinner from 'components/Common/Spinner';
import { useForm } from 'react-hook-form';
import Grid from '@mui/material/Grid2';

interface Props {
  open: 'cal_com';
  handleClose: any;
}

export default function IntegrationForm({ open, handleClose }: Props) {
  const { data: formFields, isLoading } = useGetNewIntegrationsFields(open);
  const { handleSubmit, reset, control } = useForm();
  const { mutateAsync: activateIntegration, isPending } = useCreateIntegration();

  const onSubmit = async (data: any) => {
    data.integration_name = formFields?.integration_name;
    await activateIntegration(data);
    handleClose();
    reset();
  };

  const onCloseModal = () => {
    reset();
    handleClose();
  };

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <Modal
      open={Boolean(open)}
      onClose={onCloseModal}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box sx={style}>
        <Box component='form' onSubmit={handleSubmit(onSubmit)}>
          <Typography textTransform='capitalize' variant='h6' mb={2}>
            Activate
          </Typography>
          <Grid container spacing={3}>
            {formFields?.configuration?.map((field: string, index: number) => (
              <Grid size={{ xs: 12, md: formFields?.configuration?.length > 1 ? 6 : 12 }}>
                <Input
                  key={index}
                  name={`configuration.${field}`}
                  control={control}
                  label={field?.replace(/_/g, ' ')}
                  fullWidth
                />
              </Grid>
            ))}
          </Grid>
          <Button type='submit' sx={{ marginTop: 2, marginLeft: 'auto', display: 'block' }} isPending={isPending}>
            Submit
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '1px solid #F3F3F3',
  boxShadow: 24,
  borderRadius: '8px',
  padding: 3,
  width: {
    xs: '90%',
    sm: 400,
    md: 500,
    lg: 500
  }
};
